import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import * as L from "leaflet";

@Component({
  selector: 'smart-draw-farm',
  templateUrl: './draw-farm.component.html',
  styleUrls: ['./draw-farm.component.css']
})

export class DrawFarmComponent implements OnInit, AfterViewInit {
  step=0;
  count=0;
  map: L.Map;
  map2: L.Map;
  polygon;
  marker;
  drawPluginOptions;

  numberOfSensor=[];
  numberOfLatLong=[];

  count_sensor1=0;
  count_sensor2=0;
  count_sensor3=0;
  marker_basket1=[];
  marker_basket2=[];
  marker_basket3=[];

  show_button= false;

  greenIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
  redIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
  blueIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });

  // 1 Set per Layer
  setData = [
    { 
      no: '1',
      lat: ['13.85079','13.85010','13.85090','13.85150'],
      long: ['100.52450','100.52300','100.52200','100.52350'],
      latlong:[['13.85079','100.52450'],['13.85010','100.52300'],['13.85090','100.52200'],['13.85150','100.52350']],
      color: 'red',
      color2: 'black',
      center: ['14.20300','100.52600']
    },
    {
      no: '2',
      lat: ['13.85279','13.85210','13.85290','13.85350'],
      long: ['100.52400','100.52200','100.52000','100.52150'],
      color: '#FCB4A4',
      color2: 'white',
      center: ['14.20300','100.52600']
    }    
  ]

  // 1 Set per Sensor
  setSensor = [
    {
      no: '1',
      name: 'sensor1',
      lat: ['13.85079','13.85290'],
      long: ['100.52200','100.52300'],
    },
    {
      no: '2',
      name: 'sensor2',
      lat: ['13.85090','13.85010'],
      long: ['100.52450','100.52000'],
    },
    {
      no: '3',
      name: 'sensor3',
      lat: ['13.85150','13.85350'],
      long: ['100.52350','100.52150'],
    }
  ]

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
  ) {}
  
  ngOnInit(): void {
    // this.map = L.map('map',{zoomControl: false}).setView([13.85083, 100.52222], 16);
    // L.control.zoom({position:'topright'}).addTo(this.map);
    // L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',{ maxNativeZoom: 17, maxZoom: 18, minZoom: 5 })
    // .addTo(this.map);

    // for (let i = 0; i < this.setData.length; i++) {
    //   for(let lt = 0; lt < this.setData[i].lat.length; lt++){
    //     console.log(this.setData[i].lat[lt] , this.setData[i].long[lt]);
    //     this.numberOfLatLong[lt] = [ this.setData[i].lat[lt] , this.setData[i].long[lt] ];
    //   } console.log(this.numberOfLatLong);
    //   console.log(this.setData[i].latlong);
      
    //   this.polygon = L.polygon(
    //     [
    //       [this.numberOfLatLong,],        
    //     ],
    //     {
    //       color: this.setData[i].color2,
    //       fillColor: this.setData[i].color,
    //       fillOpacity: 0.2,
    //       weight: 5,
          
    //     },
    //   ).addTo(this.map);
    //   this.polygon.on('click', function(e) {
    //     this.change_page= true;
    //     console.log("click: ",this.change_page + [i]);
    //     // this.map = L.map('map',{zoomControl: false}).setView(this.setData[i].center, 16);
    //     // L.control.zoom({position:'topright'}).addTo(this.map);
    //     // L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',{ maxNativeZoom: 17, maxZoom: 18, minZoom: 5 })
    //     // .addTo(this.map);
    //   } );
    //   console.log("done: ", [i]);
    //   console.log("test ",this.setData[i].center);
    // }
   
  }
 
  ngAfterViewInit(): void {
    this.map = L.map('map',{zoomControl: false}).setView([13.85083, 100.52222], 16);
    L.control.zoom({position:'topright'}).addTo(this.map);
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',{ maxNativeZoom: 17, maxZoom: 18, minZoom: 5 })
    .addTo(this.map);

    for (let i = 0; i < this.setData.length; i++) {
      for(let lt = 0; lt < this.setData[i].lat.length; lt++){
        console.log(this.setData[i].lat[lt] , this.setData[i].long[lt]);
        this.numberOfLatLong[lt] = [ this.setData[i].lat[lt] , this.setData[i].long[lt] ];
      } console.log(this.numberOfLatLong);
      console.log(this.setData[i].latlong);
      
      this.polygon = L.polygon(
        [
          [this.numberOfLatLong,],        
        ],
        {
          color: this.setData[i].color,
          fillColor: this.setData[i].color,
          fillOpacity: 0.2,
          
        },
      ).addTo(this.map);
      console.log(this.map)
      console.log(this.map2);
      // this.polygon.bindPopup(this.setData[i].color);
      this.polygon.on('click', function(e) {
        
        this.step = this.step+1;
        // this.map.remove().addTo(this.map);
        console.log(this.step);
        console.log("click: ", [i]);
        console.log(this.change_page);
        
        if(this.map2 == undefined){
          if(this.count == 1){
            this.map2.remove();
            (<HTMLInputElement>document.getElementById("main-page")).outerHTML = "";
            this.count--;
          }
          this.map2 = L.map('map2',{zoomControl: false}).setView([15.00000,100.65200], 16);
          L.control.zoom({position:'topright'}).addTo(this.map2);
          L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',{ maxNativeZoom: 17, maxZoom: 18, minZoom: 5 })
          .addTo(this.map2);
          this.count=this.count+1;
        }else if(this.map2 != undefined){
          this.map2.remove();
          this.map2 = L.map('map2',{zoomControl: false}).setView([16.00000,101.65200], 16);
          L.control.zoom({position:'topright'}).addTo(this.map2);
          L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',{ maxNativeZoom: 17, maxZoom: 18, minZoom: 5 })
          .addTo(this.map2);
          this.count++;
          
        }

      } );
      console.log("done: ", [i]);
      console.log(this.setData[i].center);
    }
  }

  select_farm(value:string){
    if (value == 'farm_dt') {
      this.show_button = true;
    }else{
      this.show_button = false;
    }
  }

  show_sensor1() {
    if (this.marker_basket1.length == 0) {
      console.log(this.setSensor[0]);
      for (let s = 0; s < this.setSensor.length; s++) {
        if (this.setSensor[s].no == "1") {
          for(let cs = 0; cs < this.setSensor[cs].lat.length; cs++){
            this.numberOfSensor[cs] = [ this.setSensor[s].lat[cs] , this.setSensor[s].long[cs]];
            this.marker = L.marker(this.numberOfSensor[cs], {icon: this.redIcon}).addTo(this.map);
            this.marker_basket1.push(this.marker);
          }console.log(this.numberOfSensor);
        }
      }
      console.log('sensor1 on');
      (<HTMLInputElement>document.getElementById("sensor2")).classList.add("disable");
      }else if (this.marker_basket1.length != 0) {
        for(var mi = 0; mi < this.marker_basket1.length; mi++){
          this.map.removeLayer(this.marker_basket1[mi]);
      }
      console.log('sensor1 off',this.marker_basket1.length);
      this.marker_basket1.length = 0;
    }
  }

  show_sensor2(){
    if (this.marker_basket2.length == 0) {
      for (let s = 0; s < this.setSensor.length; s++) {
        if (this.setSensor[s].no == "2") {
          for(let cs = 0; cs < this.setSensor[cs].lat.length; cs++){
            this.numberOfSensor[cs] = [ this.setSensor[s].lat[cs] , this.setSensor[s].long[cs]];
            this.marker = L.marker(this.numberOfSensor[cs], {icon: this.blueIcon}).bindPopup(this.setSensor[s].lat[cs]).addTo(this.map);
            this.marker_basket2.push(this.marker);
          }console.log(this.numberOfSensor);
        }
      }
      console.log('sensor2 on');
    }else if (this.marker_basket2.length != 0) {
      for(var mi = 0; mi < this.marker_basket2.length; mi++){
        this.map.removeLayer(this.marker_basket2[mi]);
      }
      console.log('sensor2 off',this.marker_basket2.length);
      this.marker_basket2.length = 0;
    }
  }

  show_sensor3(){
    if (this.marker_basket3.length == 0) {
      console.log(this.setSensor[2]);
      for (let s = 0; s < this.setSensor.length; s++) {
        if (this.setSensor[s].no == "3") {
          for(let cs = 0; cs < this.setSensor[cs].lat.length; cs++){
            this.numberOfSensor[cs] = [ this.setSensor[s].lat[cs] , this.setSensor[s].long[cs]];
            this.marker = L.marker(this.numberOfSensor[cs], {icon: this.greenIcon}).addTo(this.map);
            this.marker_basket3.push(this.marker);
          }console.log(this.numberOfSensor);
        }
      }
      console.log('sensor3 on');
    }else if (this.marker_basket3.length != 0) {
      for(var mi = 0; mi < this.marker_basket3.length; mi++){
        this.map.removeLayer(this.marker_basket3[mi]);
      }
      console.log('sensor3 off',this.marker_basket3.length);
      this.marker_basket3.length = 0;
    }
  }
}
